import React, { useEffect, useState } from 'react';
/*import '../Assets/Styles/addNewCarPopup.css';*/
//import car from '../Assets/Images/car.jpg'
//import "../Assets/Styles/carImages.css";
//import pencil from "../Assets/Images/pencil.svg"
//import upload from "../Assets/Images/upload.svg"
import sideImage from '../../asstes/images/add-car-left.svg';
import carIcon from '../../asstes/images/car-icon.svg';
import { Heading, Img, Button, Text, Switch } from "../../components";
import CarDetails from 'components/CarDetails';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ProposalDateRow from "../../components/ProposalDateRow";
import {API_DOMAIN_IMG, API_DOMAIN} from 'config';
/** ➋ קומפוננטת שדה-טופס קטנה (אפשר לשים בקובץ נפרד) */
import SendNewOfferColumncar10660x from "../../components/SendNewOfferColumncar10660x";
import CarCardTemplate from 'components/CarCardTemplate';
import UnderlineInput from "components/UnderlineInput";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { he } from "date-fns/locale";   
registerLocale("he", he);    
export default function ApproveOfferByProviderPopup({onClose, car, currentUser, offer})
{const [buyer, setBuyer] = useState(null);
useEffect(() => {
  // שומרים מצב קודם כדי להחזיר בדיוק
  const prevBodyOverflow = document.body.style.overflow;
  const prevHtmlOverflow = document.documentElement.style.overflow;
  const prevBodyPosition = document.body.style.position;
  const prevBodyWidth = document.body.style.width;

  // lock scroll (בעיקר במובייל)
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";
  document.body.style.position = "relative";
  document.body.style.width = "100%";

  return () => {
    // cleanup
    document.body.style.overflow = prevBodyOverflow;
    document.documentElement.style.overflow = prevHtmlOverflow;
    document.body.style.position = prevBodyPosition;
    document.body.style.width = prevBodyWidth;
  };
}, []);

useEffect(() => {
//  debugger;

  const loadBuyer = async () => {
    if (!offer?.buyerId) return;

    try {
      const { data } = await axios.get(`${API_DOMAIN}/user/getUserById`, {
        params: { id: offer.buyerId }
      });

setBuyer(data.user);
    } catch (err) {
      console.error("שגיאה בשליפת פרטי משתמש:", err);
    }
  };

  loadBuyer();
}, [offer?.buyerId]);

    const CustomInput = React.forwardRef(({ value, onClick, label }, ref) => (
        <div className="">
          <input
            ref={ref}
            readOnly
            onClick={onClick}
            value={value ?? ""}
            placeholder="__/__/__"
            /* ——— עיצוב ——— */
            className="
              w-40
              bg-transparent
              text-right
              cursor-pointer
      
              /* לא רוצים שום קו־תחתון או גבול: */
              border-0
              border-b-0        /* במקרה שיש tailwind base שמוסיף */
              ring-0            /* מבטל ring של tailwind */
              focus:ring-0
              focus:outline-none
      
              placeholder:text-gray-400
            "
          />
          <span className="text-[16px] text-black-900_03 lg:text-[13px]">
            {label}
          </span>
        </div>
      ));
    const [step, setStep] = useState(1);
    const [offerForm, setOfferForm] = useState({
        price: "",
        offerDate: new Date(),   // תאריך היום
        pickupDate: "",
        lastPaymentDate: "",
        reserve: false,
      });
    
      /** שינוי ערך */
      const handleChange = (e) => {
        const { name, value } = e.target;
        setOfferForm((prev) => ({ ...prev, [name]: value }));
      };


      const fmt = (d) =>
        d ? new Date(d).toISOString().slice(0, 19).replace("T", " ") : null;
    
      /** שליחת הטופס */
      const submitOffer = async () => {
        try {
          await Promise.resolve({
           // car_id: car?.id,
           // user_id: currentUser??.id,
           // offered_price: offerForm.price,
           // collection_date: fmt(offerForm.pickupDate),
           // last_payment_date: fmt(offerForm.lastPaymentDate),
           // is_reserved: offerForm.reserve
          });
         // alert("הצעה נשמרה בהצלחה!");
          setStep(2);
        //  onClose(true);        // סוגר את הפופ‑אפ
        } catch (err) {
          console.error(err);
          alert("אירעה שגיאה בשמירת ההצעה");
        }
      };
    return(

        <div className="popup-wrapper">
        <div className="popup-offer-container" >           
                    <button className='x-close' onClick={onClose}>✕</button>



 

          {step == 1 && (
  <div className="flex flex-col items-center justify-center h-full ">
    <h2 className="add-car-title">!!!מזל טוב</h2>
    <h2 style={{ color: 'black', marginBottom:'1rem' }} className="add-car-title">
      ההצעת מחיר אושרה בהצלחה
    </h2>
    <div className="flex justify-center w-full" style={{flexDirection: 'column'}} >
      <CarCardTemplate
        key={car?.id}
        manufacturer={car?.maker}
        images={car?.images}
        offer_status="2"
        {...car}
        className="w-full max-w-[300px] sm:w-[90%] self-center"
      /> 
      <div style={{display: 'flex', justifyContent: 'center'}}>
          <button
                          size="lg"
                          shape="round"
                          leftIcon={
                            <div className="flex h-[10px] w-[6px] items-center justify-center">
                                       <span className="text-lg leading-none">‹</span>
    
                           
                            </div>
                          }
                          className="z-10 gap-2 rounded-[16px] px-3 font-semibold text-white"
                          style={{background: '#D81C24', color: 'white', padding: '5px',width: '70%', marginTop:'1rem'}}
                          onClick={()=>{setStep(2)}}
                          >
                         לפרטי התקשרות    
                        </button>
                        </div>
    </div>
             
   
  </div>
)}










{step == 2 && (
  <div className="flex flex-col items-center justify-center h-full approved-contact ">
    <h2 className="add-car-title">!!!מזל טוב</h2>
    <h2 style={{ color: 'black', marginBottom:'1rem' }} className="add-car-title">
      ההצעת מחיר אושרה בהצלחה
    </h2>
      <div className="mx-[110px] flex items-start justify-end md:mx-0 md:flex-col">
                  <Img
                    src="/images/img_shutterstock_1832393104.png"
                    alt="Shutterstock"
                    className="h-[318px] w-[36%] self-center object-contain md:w-full"
                  />
                  <div style={{height:'10rem'}} className="mt-[42px] flex w-[48%] justify-center rounded-[20px] bg-secondary-primary_white px-[18px] py-[22px] shadow-lg md:w-full sm:py-4">
                    <div className="flex w-full items-center justify-between gap-5 sm:flex-col">
                      <div className="flex w-[58%] flex-col items-end sm:w-full">
                        <Heading
                          size="heading10xl"
                          as="h2"
                          className="text-[27px] font-semibold !text-black-900 lg:text-[22px] md:text-[21px]"
                        >
                          {buyer?.business_name}
                        </Heading>
                        <Heading
                          size="heading8xl"
                          as="h3"
                          style={{fontSize: '19px'}}

                          className="mt-1.5 text-[24px] font-bold !text-black-900 lg:text-[20px]"
                        >
                          <span>{buyer?.email}</span>
                        </Heading>
                        <div className="mt-2.5 flex flex-col items-end self-stretch">
<Heading
  size="heading12xl"
  as="h4"
  style={{ fontSize: "22px" }}
  className="relative z-[1] text-[15px] font-semibold !text-red-a700_03 sm:text-[22px]"
>
  <span className="ml-2">
    {buyer?.contact_name ? buyer.contact_name : "—"}
  </span>
  <span>
    {buyer?.phone_number ? buyer.phone_number : "—"}
  </span>
</Heading>
                        </div>
                      </div>
                      <Img
                        src="/images/img_artboard_1_copy_132x138.png"
                        alt="Artboard1copy"
                        className="h-[132px] w-[32%] rounded-[66px] object-contain sm:w-full"
                        style={{objectFit: 'none'}}
                      />
                    </div>
                  </div>
                </div>
  </div>
)}



        </div>
    </div>
  
   

    );
} 
